import { QuizQuestion } from "./QuizQuestion";

export const QuizGroup = ({ group }) => {
  // Datos del hook ----------------------------------------//
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="mb-3">{group.questionGroup.title}</h3>
        <div className="vstack gap-3">
          {group.questionGroup.questions?.map((question, questionIndex) => (
            <QuizQuestion
              key={question.id}
              question={question}
              questionIndex={questionIndex}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
